export default "__VITE_ASSET__DYf7PbMN__"